<template>
    <div>
        <PagesSmartLighting lang="en" tab="2" sub="22"></PagesSmartLighting>
    </div>
</template>

<script setup lang="ts">
import { PagesSmartLighting } from '#components';
import langObj from "@/utils/lang";
var lng: any = langObj['en']
// 中文智慧照明
useSeoMeta({
    title: lng['力士达集团'],
    description: '力士达集团',
    keywords: '力士达, lsd',
});
</script>